import Swiper from 'swiper/bundle';
import fetchJsonp from 'fetch-jsonp';

// experience
const swiperExperience = new Swiper('.js-swiper-experience', {
  grabCursor: true,
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    600: {
      slidesPerView: 3
    }
  },
  navigation: {
    nextEl: ".js-swiper-experience-next",
    prevEl: ".js-swiper-experience-prev",
  },
  pagination: {
    el: ".js-swiper-experience-pagination",
    clickable: true,
  }
});

// 洗顔セットバナー品切れ時対応
class senganNetSetZaiko {
  constructor() {
    this.$ = document.querySelector('.banners-sengan-net-set-cartbtn');

    this.senganSetBannerArr = document.querySelectorAll('.js-sengan-net-set');

    // 商品情報
    if (this.$.dataset.shohincd) {
      this.shohincd = this.$.dataset.shohincd;
      this.itemJanArr = this.shohincd.split(',');
      this.itemBorder = this.$.dataset.border ? this.$.dataset.border : 10;
    }

    // 景品情報
    if (this.$.querySelector('.js-zaiko-gift')) {
      this.giftInput = this.$.querySelector('.js-zaiko-gift');
      this.giftShohincd = this.giftInput.dataset.shohincd;
      this.giftJanArr = this.giftShohincd.split(',');
      this.giftBorder = this.giftInput.dataset.border ? this.giftInput.dataset.border : 10;
    }

    // 在庫API情報
    this.domain = document.domain;
    this.apiPath = "/sw/products/SWFG070740.seam";
    this.janParamKey = '&shohin_cd=';

    this.initialize();

  }

  async initialize() {

    // ドメイン判定&API URLセット
    let domain = '';
    if (this.domain.indexOf('shiseido.co.jp') === -1) {
      domain = 'https://www.shiseido.co.jp';
    }
    let apiURL = domain + this.apiPath;

    // 在庫判定文字列初期化
    let zaiko = '';
    let itemZaiko = '';
    let giftZaiko = '';

    // 商品在庫
    if (this.shohincd) {
      let itemParam = this.janParamKey + this.itemJanArr.join(this.janParamKey);
      itemParam = '?border=' + this.itemBorder + '&shohin_kbn=1' + itemParam;
      const itemRes = await fetchJsonp(apiURL + itemParam);
      const itemData = await itemRes.json();
      itemZaiko = itemData.map(function (value) {
        return value.zaiko_kbn;
      });
      zaiko += ',' + itemZaiko;
    }

    // 景品在庫
    if (this.giftShohincd) {
      let giftParam = this.janParamKey + this.giftJanArr.join(this.janParamKey);
      giftParam = '?border=' + this.giftBorder + '&shohin_kbn=2' + giftParam;
      const giftRes = await fetchJsonp(apiURL + giftParam);
      const giftData = await giftRes.json();
      giftZaiko = giftData.map(function (value) {
        return value.zaiko_kbn;
      });
      zaiko += ',' + giftZaiko;
    }

    if (this.zaikoJudge(zaiko) === 0 || this.zaikoJudge(zaiko) === 9) {
      this.senganSetBannerArr.forEach(element => {
        element.style.display = 'none';
      });
    } else {
      this.senganSetBannerArr.forEach(element => {
        element.style.opacity = 1;
      });
    }

  }

  zaikoJudge(str) {
    if (str.indexOf('9') != -1) {
      return 9;
    } else if (str.indexOf('0') != -1) {
      return 0;
    } else if (str.indexOf('2') != -1) {
      return 2;
    } else if (str.indexOf('1') != -1) {
      return 1;
    }
  }
}

new senganNetSetZaiko();
